import React from 'react';


export const PostgreSQL = props => {
    return (
        <img className={props.className} src={require('../../../resources/images/png_icons/postgreSQL.png')} />
    )
};
